<template>
  <div class="AntWithHold">
    <el-button
      @click="createByDocTemplate()"
      type="warning"
      size="mini"
      v-if="
        item.fasu_zxsqs == '' ||
          item.fasu_sqxy == '' ||
          item.fasu_status == 0
      "
      >生成征信授权文件</el-button
    >
    <el-dropdown
      split-button
      type="info"
      size="mini"
      v-else
    >
      征信查询授权文件
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <el-button @click="gockaq('fasu_zxsqs')" type="warning" size="mini"
            >个人征信授权书</el-button
          >
        </el-dropdown-item>
        <el-dropdown-item>
          <el-button @click="gockaq('fasu_sqxy')" type="primary" size="mini"
            >授权协议</el-button
          >
        </el-dropdown-item>
        <!-- <el-dropdown-item>
          <el-button @click="gockaq('huacan_zztzs')" type="primary" size="mini"
            >债权通知书</el-button
          >
        </el-dropdown-item> -->
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<style lang="scss" scoped>
.el-dropdown-menu__item + .el-dropdown-menu__item {
  margin-top: 5px;
}
</style>

<script>
import OrderApi from "@/api/order.js";
export default {
  name: "eqbContract",
  props: {
    item: Object
  },
  data() {
    return {
      order_id: "",
      list: ["shouquanshu", "danbao", "zhaizhuan"]
    };
  },
  created() {
    console.log(this.item , '查看数据---------------');
  },
  methods: {
    gockaq(val) {
      window.open(this.item[val], "_blank");
    },
    // 生成公证文件
    createByDocTemplate() {
      const promises = this.list.map(item => {
        return this.createByDocTemplate3(item);
      });
      Promise.all(promises)
        .then(() => {
          console.log("所有文档模板生成成功");
          this.$emit("closeEqb", {});
          window.location.reload();
        })
        .catch(err => {
          console.error("生成文档模板时发生错误:", err);
        });
    },
    createByDocTemplate3(item) {
      console.log(item, "item");
      let data = {
        order_id: this.item.order_id,
        type: item
      };
      return OrderApi.createByDocTemplate3(data, true)
        .then(res => {
          this.$message({
            type: "success",
            message: "生成成功"
          });
          return res;
        })
        .catch(err => {
          throw err;
        });
    }
  },
  created() {
    // console.log(this.item);
  }
};
</script>
<style lang="scss">
.AntWithHold {
  .el-button-group {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/AntWithHold/eqbContract.vue